import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { CustomPipesModule } from "@app/_pipes/custom-pipes.module";
import { FilterTriggerButtonModule } from "@app/components/filter-trigger-button/filter-trigger-button.module";
import { MaterialModule } from "@app/material.module";
import { TagPickerDialogModule } from "@app/shared/dialogs/tag-picker-dialog/tag-picker-dialog.module";
import { TimeInputModule } from "@app/shared/time-input/time-input.module";
import { TimeRangePickerModule } from "@app/shared/time-range-picker/time-range-picker.module";
import { UserAvatarModule } from "@app/shared/user-avatar/user-avatar.module";
import { TranslateModule } from "@ngx-translate/core";
import { DateFnsModule } from "ngx-date-fns";
import { AbsenceConflictDialogModule } from "../absence-conflict-dialog/absence-conflict-dialog.module";
import { DurationInputControlModule } from "../duration-input-control/duration-input-control.module";
import { EmployeeFilterPopoverModule } from "../employee-filter-popover/employee-filter-popover.module";
import { UserSinglePickerDialogModule } from "../user-single-picker-dialog/user-single-picker-dialog.module";
import { ComeAndGoAbsenceDialogComponent } from "./come-and-go-absence-dialog.component";

@NgModule({
	declarations: [ComeAndGoAbsenceDialogComponent],
	imports: [
		AbsenceConflictDialogModule,
		CommonModule,
		MaterialModule,
		FormsModule,
		ReactiveFormsModule,
		TranslateModule,
		DateFnsModule,
		UserAvatarModule,
		UserSinglePickerDialogModule,
		TimeInputModule,
		TagPickerDialogModule,
		EmployeeFilterPopoverModule,
		FilterTriggerButtonModule,
		TimeRangePickerModule,
		DurationInputControlModule,
		CustomPipesModule,
	],
})
export class ComeAndGoAbsenceDialogModule {}
